import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyAArqkpQ0_iER4r0lEwGg-Qc6K4PskLN4k",
    authDomain: "chatbot-b7f89.firebaseapp.com",
    projectId: "chatbot-b7f89",
    storageBucket: "chatbot-b7f89.appspot.com",
    messagingSenderId: "23541399607",
    appId: "1:23541399607:web:8a28dfc82f5d4d0e10ffb2",
    measurementId: "G-MJEXDP3YML"
});

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };